import React, { useEffect, useState } from "react";
import ScheduleAssessBox from "./ScheduleAssessBox";
import axios from "../../../../../axios";

const SchedAssePropsBox = ({ filter }) => {
  const [scheduledAssesssmentList, setScheduledAssessmentList] = useState([]);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [inDeactiveProcess, setDeactiveProcess] = useState(false);
  const [isGettingData, setIsGettingData] = useState(true);

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  useEffect(() => {
    const getScheduledAssessment = async () => {
      try {
        let res = await axios.get(
          `/api/v1/assessment/filterByTeacherId/${teacher_id}/scheduled?sortBy=-1&_page=1&_limit=100&academicSessionId=${academicSessionId}&timetableSessionId=${timeTableSessionId}` +
            `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
            `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
            `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
            `&${filter?.date && `date=${filter?.date}`}` +
            `&${filter?.time && `time=${filter?.time}`}` +
            `&${
              filter?.subjectId?.length !== 0 &&
              `subjectId=${filter?.subjectId}`
            }`,
        );
        res &&
          localStorage.setItem(
            "ScheduledAssessmentData",
            JSON.stringify(res.data.data),
          );
        setScheduledAssessmentList(res.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    getScheduledAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, inDeactiveProcess]);
  return (
    <>
      {scheduledAssesssmentList.length > 0 ? (
        <div className="container">
          <div className="row">
            {scheduledAssesssmentList.map((assessment, index) => (
              <div key={index} className="col-md-3 d-flex mb-3">
                <ScheduleAssessBox
                  key={index}
                  setDeactiveProcess={setDeactiveProcess}
                  assessment={assessment}
                />
              </div>
            ))}
          </div>
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <div className="d-flex justify-content-center align-items-center w-100">
          <span
            className="px-2 py-2 d-flex align-items-center gap-2"
            style={{ fontSize: "1.2rem", fontWeight: 500 }}
          >
            🧾 Assessment Not Found
          </span>
        </div>
      )}
    </>
  );
};

export default SchedAssePropsBox;
